<div class="frontpage-widget cover-image-mose-gray">
    <div class="whitebox gray">
        <div class="container">
            <p class="text-muted">
                RISIKOVURDERING
                <i class="fa fa-chevron-right"></i>
            </p>
            <h2>{{location?.number}} - {{location?.name}}</h2>
            <p>
                <span class="text-muted">Sagsbehandler: </span>
                <a>{{location?.caseWorker?.name}}</a>
            </p>
            <p>
                <!-- <span class="text-muted">Status: </span>
                <ng-container [ngSwitch]="location?.origin">
                    <span class="location-origin" *ngSwitchCase="locationOrigin.Screening">
                        Lokaliteten er screenet
                    </span>
                    <span class="location-origin" *ngSwitchCase="locationOrigin.NoModelCompoundsFound">
                        Lokaliteten har i screeningen ingen modelstoffer og blev derfor ikke screenet
                    </span>
                    <span class="location-origin" *ngSwitchCase="locationOrigin.PublicAction">
                        Lokaliteten har i screeningen offentlig indsats udført og blev derfor ikke screenet
                    </span>
                    <span class="location-origin" *ngSwitchCase="locationOrigin.V1asV2Calculation">
                        Lokaliteten er oprettet som V1 som V2 lokalitet
                    </span>
                    <span class="location-origin" *ngSwitchCase="locationOrigin.External">
                        Oprettet af eksterne bruger
                    </span>
                </ng-container> -->
                <span class="text-muted">Lokalitetsstatus: </span>
                <span class="location-origin" >
                    {{ location?.locationPollutionStatusDescription }}
                </span>
            </p>
            <p *ngIf="location.isLandfill" i18n>Losseplads</p>
        </div>
    </div>
</div>

<div class="container mb-5">
    <div *ngIf="!publicActionPerformed">
        <div class="row mt-5 ">
            <div class="col-md-8 alert alert-secondary p-4"
                style="background: #F4F7F9; border-color:rgba(201, 201, 219, 0.356)">
                <h4><i class="fa fa-exclamation-circle"></i>Lokalitet ikke i risikovurdering</h4>
                <p class="mb-0">Denne lokalitet er ikke i risikovurdering. Du kan frit foretage <b>v1 som v2</b>
                    beregninger, men ikke opløfte disse til godkendte beregninger. Se lokaliteten i
                    <a [routerLink]="['/screening/location-details', location?.id]">screening</a>
                    for at starte <i>v1 som v2</i> beregning</p>
            </div>
        </div>
    </div>
    <div *ngIf="publicActionPerformed">
        <div class="row mt-5">

            <div class="col-sm-12 col-lg-12">
                <h4 i18n>{{ isExternalUser ? 'Endelige risikovurderinger' : 'Godkendte risikoberegninger' }}</h4>
                <strong class="text-muted" i18n *ngIf="isExternalUser">Alle beregninger på denne lokalitet kan blive
                    slettet hvis de er mere end 90 dage gamle.</strong>
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Dato</th>
                            <th>Forureningsstof</th>
                            <th>Risikovurdering</th>
                            <th>Overskridelsesfaktor</th>
                            <th>Koncentration</th>
                            <th>Kvalitetskriterie</th>
                            <th>Beregningsmodel</th>
                            <th>Sagsbehandler</th>
                            <th>Bemærkning</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let calc of location.approvedCalculations"
                            (click)="goToCalculationResults(calc.id);">
                            <td class="text-muted">{{calc.createdAt | date:'d/M/yyyy HH:mm'}}</td>
                            <td>{{calc.compoundName}}</td>
                            <td>
                                <span class="fa-stack risk-indicator"
                                    [ngClass]="{'risk-computed':(calc.riskAssessment==riskAssessmentStatus.Risk), 'no-risk-computed':(calc.riskAssessment==riskAssessmentStatus.NoRisk)}">

                                </span>
                                <span [ngSwitch]="calc.riskAssessment" style="vertical-align:text-bottom">
                                    <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                        <b>Risiko</b>
                                    </span>
                                    <span *ngSwitchCase="riskAssessmentStatus.NoRisk">Ingen risiko</span>
                                </span>
                            </td>
                            <td>
                                <span [ngSwitch]="calc.riskAssessment">
                                    <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                        <b>{{getValidNumber(calc.excessFactor) | number:'1.0-1'}}</b>
                                    </span>
                                    <span *ngSwitchCase="riskAssessmentStatus.NoRisk">
                                        {{getValidNumber(calc.excessFactor) | number:'1.0-1'}}
                                    </span>
                                </span>
                            </td>
                            <td>{{getNumberWithSignificantDigits(calc.concentration)}} µg/L</td>
                            <td>
                                {{getValidNumber(calc.qualityCriterion) | number:'1.0-5'}} µg/L
                                {{ calc.qualityCriterionType === qualityCriterionType.Fictitious ? '(*)' : '' }}
                            </td>
                            <td>
                                <span class="model-indicator">
                                    <i class="model-icon"></i>
                                    <span class="model-number">{{calc.calculationModelType}}</span>
                                </span>
                                <span class="text-muted">(nedbrydning:</span>
                                <span *ngIf="!calc.hasDegradation"> nej</span>
                                <span *ngIf="calc.hasDegradation"> ja</span>
                                <span class="text-muted">)</span>
                            </td>
                            <td>{{calc.caseWorker.name}}</td>
                            <td *ngIf="calc.latestComment">
                                <div class="comment-wrapper"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    [attr.title]="calc.latestComment">
                                    <span class="text-muted comment-ellipsis">"{{calc.latestComment}}"</span>
                                </div>
                            </td>
                            <td *ngIf="!calc.latestComment" (click)="$event.stopPropagation();">
                                <a (click)="showAddCommentModal(calc.id)" class="text-uppercase">Tilføj bemærkning</a>
                            </td>
                            <td (click)="$event.stopPropagation();">
                                <a (click)="showUnapproveCalculationModal(calc.id)" title="Fjern godkendelse"
                                    style="color: #000 !important;">
                                    <span>
                                        <i class="fa fa-times fa-lg"></i>
                                        <!-- <span class="text-uppercase"> fjern</span> -->
                                    </span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <span
                    *ngIf="location.approvedCalculations && location.approvedCalculations.length"
                    class="text-muted">
                    (*) fiktiv værdi er anvendt.
                </span>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-sm-12 col-lg-12">
                <h4 class="d-inline-block" i18n>Risikoberegninger</h4>
                <a href="javascript:void(0)" class="text-uppercase float-right btn btn-primary btn-sm"
                    (click)="newCalculation(null)">
                    <i class="fa fa-plus-circle fa-lg"></i>
                    <span class="text-uppercase"> ny beregning</span>
                </a>
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Dato</th>
                            <th>Forureningsstof</th>
                            <th>Risikovurdering</th>
                            <th>Overskridelsesfaktor</th>
                            <th>Koncentration</th>
                            <th>Kvalitetskriterie</th>
                            <th>Beregningsmodel</th>
                            <th>Sagsbehandler</th>
                            <th>Bemærkning</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let calc of allNoneApprovedCalculations"
                            (click)="goToCalculationResults(calc.id);">
                            <td class="text-muted">{{calc.createdAt | date:'d/M/yyyy HH:mm'}}</td>
                            <ng-container *ngIf="!calc.isInProgress && !calc.calculationFailed">
                                <td>{{calc.compoundName}}</td>
                                <td>
                                    <span class="fa-stack risk-indicator"
                                        [ngClass]="{'risk-computed':(calc.riskAssessment==riskAssessmentStatus.Risk), 'no-risk-computed':(calc.riskAssessment==riskAssessmentStatus.NoRisk)}">

                                    </span>
                                    <span [ngSwitch]="calc.riskAssessment" style="vertical-align:text-bottom">
                                        <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                            <b>Risiko</b>
                                        </span>
                                        <span *ngSwitchCase="riskAssessmentStatus.NoRisk">Ingen risiko</span>
                                    </span>
                                </td>
                                <td>
                                    <span [ngSwitch]="calc.riskAssessment">
                                        <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                            <b>{{getValidNumber(calc.excessFactor) | number:'1.0-1'}}</b>
                                        </span>
                                        <span *ngSwitchCase="riskAssessmentStatus.NoRisk">
                                            {{getValidNumber(calc.excessFactor) | number:'1.0-1'}}
                                        </span>
                                    </span>
                                </td>
                                <td>{{getNumberWithSignificantDigits(calc.concentration)}} µg/L</td>
                                <td>
                                    {{getValidNumber(calc.qualityCriterion) | number:'1.0-5'}} µg/L
                                    {{ calc.qualityCriterionType === qualityCriterionType.Fictitious ? '(*)' : '' }}
                                </td>
                                <td class="text-nowrap">
                                    <span class="model-indicator">
                                        <i class="model-icon"></i>
                                        <span class="model-number">{{calc.calculationModelType}}</span>
                                    </span>
                                    <span class="text-muted">(nedbrydning:</span>
                                    <span *ngIf="!calc.hasDegradation"> nej</span>
                                    <span *ngIf="calc.hasDegradation"> ja</span>
                                    <span class="text-muted">)</span>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="calc.isInProgress">
                                <td colspan="6">Beregner...</td>
                            </ng-container>

                            <ng-container *ngIf="calc.calculationFailed">
                                <td colspan="6">
                                    <div class="alert alert-danger m-0 p-1" role="alert">
                                        <b><i class="fa fa-exclamation fa-lg"></i>Beregningen fejlede:</b>
                                        {{calc.calculationFailedErrorMessage}}
                                    </div>

                                </td>
                            </ng-container>

                            <td>{{calc.caseWorker?.name}}</td>

                            <td *ngIf="calc.latestComment">
                                <div class="comment-wrapper" 
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    [attr.title]="calc.latestComment">
                                    <span class="text-muted comment-ellipsis">"{{calc.latestComment}}"</span>
                                </div>
                            </td>
                            <td *ngIf="!calc.latestComment" (click)="$event.stopPropagation();">
                                <a (click)="showAddCommentModal(calc.id)" class="text-uppercase">Tilføj bemærkning</a>
                            </td>

                            <td (click)="$event.stopPropagation();">
                                <a *ngIf="!calc.isInProgress && !calc.calculationFailed"
                                    (click)="showApproveCalculationModal(calc.id)">
                                    <span class="text-nowrap">
                                        <i class="fa fa-check fa-lg"></i>
                                        <span class="text-uppercase"> Godkend</span>
                                    </span>
                                </a>
                            </td>

                            <td (click)="$event.stopPropagation();">
                                <a *ngIf="!calc.isInProgress" (click)="showDeleteCalculationModal(calc.id)"
                                    title="Slet beregning" style="color: #000 !important;">
                                    <span>
                                        <i class="fa fa-trash fa-lg"></i>
                                        <!-- <span class="text-uppercase"> Slet</span> -->
                                    </span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <span
                    *ngIf="location.unapprovedCalculations && location.unapprovedCalculations.length"
                    class="text-muted">
                    (*) fiktiv værdi er anvendt.
                </span>
            </div>
        </div>
    </div>

    <!-- <div *ngIf="location?.v1Calculations && location?.v1Calculations.length > 0" class="row mt-5">
        <div class="col-sm-12 col-lg-12">
            <h4 i18n>V1 som V2 beregninger</h4>

            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Dato</th>
                        <th>Forureningsstof</th>
                        <th>Risikovurdering</th>
                        <th>Overskridelsesfaktor</th>
                        <th>Koncentration</th>
                        <th>Kvalitetskriterie</th>
                        <th>Beregningsmodel</th>
                        <th>Sagsbehandler</th>
                        <th>Bemærkning</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let calc of location.v1Calculations" (click)="goToCalculationResults(calc.id);">
                        <td class="text-muted">{{calc.createdAt | date:'d/M/yyyy HH:mm'}}</td>
                        <ng-container *ngIf="!calc.isInProgress && !calc.calculationFailed">
                            <td>{{calc.compoundName}}</td>
                            <td>
                                <span class="fa-stack risk-indicator"
                                    [ngClass]="{'risk-computed':(calc.riskAssessment==riskAssessmentStatus.Risk), 'no-risk-computed':(calc.riskAssessment==riskAssessmentStatus.NoRisk)}">

                                </span>
                                <span [ngSwitch]="calc.riskAssessment" style="vertical-align:text-bottom">
                                    <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                        <b>Risiko</b>
                                    </span>
                                    <span *ngSwitchCase="riskAssessmentStatus.NoRisk">Ingen risiko</span>
                                </span>
                            </td>
                            <td>
                                <span [ngSwitch]="calc.riskAssessment">
                                    <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                        <b>{{getValidNumber(calc.excessFactor) | number:'1.0-1'}}</b>
                                    </span>
                                    <span *ngSwitchCase="riskAssessmentStatus.NoRisk">
                                        {{getValidNumber(calc.excessFactor) | number:'1.0-1'}}
                                    </span>
                                </span>
                            </td>
                            <td>{{getNumberWithSignificantDigits(calc.concentration)}} µg/L</td>
                            <td>{{getValidNumber(calc.qualityCriterion) | number:'1.0-5'}} µg/L</td>
                            <td class="text-nowrap">
                                <span class="model-indicator">
                                    <i class="model-icon"></i>
                                    <span class="model-number">{{calc.calculationModelType}}</span>
                                </span>
                                <span class="text-muted">(nedbrydning:</span>
                                <span *ngIf="!calc.hasDegradation"> nej</span>
                                <span *ngIf="calc.hasDegradation"> ja</span>
                                <span class="text-muted">)</span>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="calc.isInProgress">
                            <td colspan="6">Beregner...</td>
                        </ng-container>

                        <ng-container *ngIf="calc.calculationFailed">
                            <td colspan="6">
                                <div class="alert alert-danger m-0 p-1" role="alert">
                                    <b><i class="fa fa-exclamation fa-lg"></i>Beregningen fejlede:</b>
                                    {{getEllipsisText(calc.calculationFailedErrorMessage, 250)}}
                                </div>

                            </td>
                        </ng-container>

                        <td>{{calc.caseWorker?.name}}</td>

                        <td *ngIf="calc.latestComment"><span class="text-muted">"{{calc.latestComment}}"</span></td>
                        <td *ngIf="!calc.latestComment" (click)="$event.stopPropagation();">
                            <a (click)="showAddCommentModal(calc.id)" class="text-uppercase text-nowrap">Tilføj
                                bemærkning</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div> -->

    <!-- <div *ngIf="location" class="row mt-5" [hidden]="isExternalUser">
        <div class="col-sm-12 col-lg-12">
            <h4 class="d-inline-block" i18n>Screeninger på denne lokalitet</h4>
            <a href="javascript:void(0)" class=" float-right  btn btn-primary btn-sm"
                (click)="showScreeningHistoryModal()">
                <i class="fa fa-history fa-lg"></i>
                <span class="text-uppercase"> Se Screeningshistorik</span>
            </a>
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Dato</th>
                        <th>Forureningsstof</th>
                        <th>Risikovurdering</th>
                        <th>Overskridelsesfaktor</th>
                        <th>Koncentration</th>
                        <th>Kvalitetskriterie</th>
                        <th *ngIf="publicActionPerformed"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let calc of location.screeningResults">
                        <td class="text-muted">{{calc.createdAt | date:'d/M/yyyy'}}</td>
                        <td>{{calc.compoundName}}</td>
                        <td>
                            <span class="fa-stack risk-indicator"
                                [ngClass]="{'risk-screening':(calc.riskAssessment==riskAssessmentStatus.Risk), 'no-risk-screening':(calc.riskAssessment==riskAssessmentStatus.NoRisk)}">

                            </span>
                            <span [ngSwitch]="calc.riskAssessment" style="vertical-align:text-bottom">
                                <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                    <b>Risiko</b>
                                </span>
                                <span *ngSwitchCase="riskAssessmentStatus.NoRisk">Ingen risiko</span>
                            </span>
                        </td>
                        <td>
                            <span [ngSwitch]="calc.riskAssessment">
                                <span *ngSwitchCase="riskAssessmentStatus.Risk">
                                    <b>{{getValidNumber(calc.excessFactor) | number:'1.0-1'}}</b>
                                </span>
                                <span *ngSwitchCase="riskAssessmentStatus.NoRisk">
                                    {{getValidNumber(calc.excessFactor) | number:'1.0-1'}}
                                </span>
                            </span>
                        </td>
                        <td>{{getNumberWithSignificantDigits(calc.concentration)}} µg/L</td>
                        <td>
                            {{ getValidNumber(calc.qualityCriterion) | number:'1.0-5' }}
                            µg/L
                            {{ calc.qualityCriterionType === qualityCriterionType.Fictitious ? '(*)' : '' }}
                        </td>
                        <td class="text-right" *ngIf="publicActionPerformed">
                            <a (click)="newCalculation(calc)">
                                <span i18n>
                                    <i class="fa fa-plus-circle fa-lg"></i>
                                    <span class="text-uppercase"> ny beregning</span>
                                </span>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <span *ngIf="location.screeningResults && location.screeningResults.length"
                class="text-muted">
                (*) fiktiv værdi er anvendt.
            </span>
        </div>
    </div> -->

    <button #approveCalculationModalButton style="display:none;" data-toggle="modal"
        data-target="#modalApproveCalculation"></button>
    <button #addCommentModalButton style="display:none;" data-toggle="modal" data-target="#modalAddComment"></button>
    <button #unapproveCalculationModalButton style="display:none;" data-toggle="modal"
        data-target="#modalUnapproveCalculation"></button>
    <button #deleteCalculationModalButton style="display:none;" data-toggle="modal"
        data-target="#modalDeleteCalculation"></button>
    <button #showScreeningHistoryButton style="display:none;" data-toggle="modal"
        data-target="#screeningHistory"></button>

    <div class="modal fade" id="modalApproveCalculation" tabindex="-1" role="dialog">
        <div class="modal-dialog " role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Godkend beregning</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body p-5">
                    <textarea #approvalMessage class="form-control" placeholder="Tilføj note..." rows="2"></textarea>
                </div>
                <div class="modal-footer">
                    <button (click)="approveCalculationFromModal(approvalMessage.value)" type="button"
                        class="btn btn-primary" data-dismiss="modal">Godkend</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fortryd</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="modalUnapproveCalculation" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Fjern godkendelse</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>
                        <span><b>Bemærk:</b> Beregningen vil stadig være tilgængelig i listen af foreløbige
                            beregninger</span>
                    </p>
                    <textarea #unapprovalMessage class="form-control" placeholder="Tilføj note..." rows="2"></textarea>
                </div>
                <div class="modal-footer">
                    <button (click)="unapproveCalculationFromModal(unapprovalMessage.value)" type="button"
                        class="btn btn-primary" data-dismiss="modal">OK</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fortryd</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="modalDeleteCalculation" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Slet beregning</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <span><b>Bemærk:</b> Beregningen vil ikke kunne genfindes hvis den slettes</span>
                </div>
                <div class="modal-footer">
                    <button (click)="deleteCalculationFromModal()" type="button" class="btn btn-primary"
                        data-dismiss="modal">Slet</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fortryd</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="modalAddComment" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Tilføj note</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <textarea #textMessage class="form-control" placeholder="Skriv note..." rows="2"></textarea>
                </div>
                <div class="modal-footer">
                    <button (click)="addCommentFromModal(textMessage.value)" type="button" class="btn btn-primary"
                        data-dismiss="modal">Tilføj</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fortryd</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="location" class="modal fade" id="screeningHistory" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content p-4">

                <div class="modal-body">
                    <h2>Screeningshistorik</h2>
                    <p class="text-muted">{{location?.number}} - {{location?.name}}</p>

                    <div *ngIf="!isHistoryLoaded" class="mt-5 text-center">
                        <app-load-indicator style="width: 20px; height: 20px;"></app-load-indicator>
                        <h6 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Henter historik... </h6>
                        <p class="text-muted mt-1">Det tager et øjeblik</p>
                    </div>

                    <div *ngIf="isHistoryLoaded">
                        <div *ngIf="screeningHistories != null && screeningHistories.length == 0">
                            <hr class="mt-4 mb-2" />
                            <h6 class="vd-text-muted">Ingen screeninger...</h6>
                        </div>
                        <div *ngFor="let screeningHistory of screeningHistories; let i = index" class=" mb-4">
                            <h6 data-toggle="collapse" [ngClass]="{'collapsed': i != 0}" style="cursor: pointer"
                                [attr.data-target]="'#' + screeningHistory.dataTarget" [attr.aria-expanded]="i == 0"
                                [attr.aria-controls]="screeningHistory.dataTarget"><i class="fa "></i> Screening
                                {{screeningHistory.createdAt | date:'d/M - y'}}</h6>

                            <div class="collapse collapse-content" [ngClass]="{'show': i == 0}"
                                [id]="screeningHistory.dataTarget">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Forureningsstof</th>
                                            <th>Risikovurdering</th>
                                            <th>Overskridelsesfaktor</th>
                                            <th>Koncentration</th>
                                            <th>Kvalitetskriterie</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{screeningHistory.compoundName}}</td>
                                            <td>
                                                <span class="fa-stack risk-indicator"
                                                    [ngClass]="{'risk-screening':(screeningHistory.excessFactor >= 1.0), 'no-risk-screening':(screeningHistory.excessFactor < 1.0)}">

                                                </span>
                                                <span [ngSwitch]="screeningHistory.excessFactor >= 1.0"
                                                    style="vertical-align:text-bottom">
                                                    <span *ngSwitchCase="true">
                                                        <b>Risiko</b>
                                                    </span>
                                                    <span *ngSwitchCase="false">Ingen
                                                        risiko</span>
                                                </span>
                                            </td>
                                            <td>
                                                <span [ngSwitch]="screeningHistory.excessFactor >= 1.0">
                                                    <span *ngSwitchCase="true">
                                                        <b>{{getValidNumber(screeningHistory.excessFactor) | number:'1.0-1'}}</b>
                                                    </span>
                                                    <span *ngSwitchCase="false">
                                                        {{getValidNumber(screeningHistory.excessFactor) | number:'1.0-1'}}
                                                    </span>
                                                </span>
                                            </td>
                                            <td>{{getNumberWithSignificantDigits(screeningHistory.concentration)}} µg/L
                                            </td>
                                            <td>
                                                {{getValidNumber(screeningHistory.qualityCriterion) | number:'1.0-5'}}
                                                µg/L
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                    <button class="btn btn-primary float-right mt-3" data-dismiss="modal"><i
                            class="fa fa-arrow-circle-left fa-lg"></i> Tilbage</button>
                </div>
            </div>
        </div>
    </div>
</div>